
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { SubsidiaryDetailStoreReducer } from './reducer';
import { SubsidiaryDetailStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, SubsidiaryDetailStoreReducer),
		EffectsModule.forFeature([SubsidiaryDetailStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SubsidiaryDetailStoreModule { }
